import { jsx as _jsx } from "react/jsx-runtime";
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { ImageMagnify, useMediaQueryMatchesOnMobile, useIsClient } from '@yonderland/andes-react';
import { ProductImageHeight, ProductImageWidth } from '../../../constants/ProductConstants';
import { getVideoPlayerType } from '../../../util/VideoUtil';
import { Video } from '../../video/Video';
const PLACEHOLDER_SRC = `data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D`;
export const ProductMediaItem = ({ sourceSet, video, alt, isActive = true, pinchZoomRef, preloadLargeImage, slideInView = true, tapZoomEnabled, stop, onClick, }) => {
    var _a;
    const isClient = useIsClient();
    const isMobile = useMediaQueryMatchesOnMobile({
        isSsr: !isClient,
    });
    if (video && ((_a = video.productVideoDetail) === null || _a === void 0 ? void 0 : _a.url)) {
        return (_jsx(Video, { url: video.productVideoDetail.url, playerType: getVideoPlayerType(video.productVideoDetail.url), stop: stop }));
    }
    return (_jsx(ImageMagnify, { smallImage: Object.assign({ src: slideInView ? sourceSet[ProductImageSizesPortraitEnum.detail] : PLACEHOLDER_SRC, width: ProductImageWidth.DETAIL, height: ProductImageHeight.DETAIL }, (!slideInView ? { 'data-src': sourceSet[ProductImageSizesPortraitEnum.detail] } : {})), largeImage: {
            src: sourceSet[ProductImageSizesPortraitEnum.zoom],
            width: ProductImageWidth.ZOOM,
            height: ProductImageHeight.ZOOM,
        }, alt: alt, onClick: onClick, mode: isMobile ? 'pinch' : 'default', isActive: isActive, pinchZoomRef: pinchZoomRef, preloadLargeImage: preloadLargeImage, tapZoomEnabled: tapZoomEnabled }));
};
